"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppSearchDialog = exports.AppSearchDialogDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var app_search_select_1 = require("./app-search-select");
var use_modal_1 = require("../../hooks/use-modal");
exports.AppSearchDialogDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n    width: 100%;\n    max-height: 90vh; \n    max-width: 90vw;\n    box-shadow: 0px 2px 5px -3px rgba(0, 0, 0, 0.6); \n  "], ["\n    background: ", ";\n    width: 100%;\n    max-height: 90vh; \n    max-width: 90vw;\n    box-shadow: 0px 2px 5px -3px rgba(0, 0, 0, 0.6); \n  "])), theme_1.theme.COLOR('app-chrome')),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    max-width: 80vw;\n  "], ["\n    max-width: 80vw;\n  "]))),
  desktopLarge: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    max-width: 65vw;\n  "], ["\n    max-width: 65vw;\n  "])))
});
var SearchContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: ", " 0;\n  "], ["\n    padding: ", " 0;\n  "])), theme_1.theme.UNIT(3))
});
var SearchStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var RecentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin: ", ";\n    padding-bottom: ", ";\n    height: 240px;\n  "], ["\n    margin: ", ";\n    padding-bottom: ", ";\n    height: 240px;\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(2)),
  tablet: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    padding-bottom: ", ";\n    height: 640px;\n  "], ["\n    padding-bottom: ", ";\n    height: 640px;\n  "])), theme_1.theme.UNIT(5))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  SearchContainer: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), SearchContainerStyles),
  Search: (0, styled_components_1.default)(app_search_select_1.AppSearchSelect)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), SearchStyles)
};
var AppSearchDialog = function (props) {
  var className = props.className;
  var modal = (0, use_modal_1.useModal)();
  var onKeyDown = function (event) {
    if (event.keyCode === 27) {
      modal.hide();
    }
  };
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.SearchContainer, null, react_1.default.createElement(My.Search, {
    maxMenuHeight: "80vh",
    showDescriptions: true,
    indentUnits: 4,
    onKeyDown: onKeyDown,
    onSelect: function () {
      return modal.hide();
    },
    variant: "chromeless"
  })));
};
exports.AppSearchDialog = AppSearchDialog;
exports.AppSearchDialog.defaultProps = exports.AppSearchDialogDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;